import MyPortfolio from "../assets/images/Myportfolio.png";
import MyPortal from "../assets/images/MyPortal.png";
import Gatsbysite from "../assets/images/Gatsbysite.png";
import EventManagement from "../assets/images/event-management.png";

export const projectsData = [
  {
    id: 1,
    projectName: "Portfolio",
    projectDesc: "This is my portfoilio website.",
    tags: ["React", "CSS", "Bootstrap"],
    code: "https://github.com/KRRISHMK/Fog-Fashion",
    demo: "https://makesh.netlify.app/",
    ImgUrl: MyPortfolio,
  },
  {
    id: 2,
    projectName: "My Portal",
    projectDesc:
      "This is my own project, It is Admin platform integrated email and so many APIs",
    tags: ["React", "Node", "Postgres Sql", "Bootstrap", "SASS"],
    code: "https://github.com/KRRISHMK/SSP-Technologies",
    demo: "https://myportalsite.netlify.app",
    flag: "Inprogress",
    ImgUrl: MyPortal,
  },
  {
    id: 3,
    projectName: "Event Management",
    projectDesc: "This is a Event management system using Rest APIs",
    tags: ["React", "SASS", "Bootstrap"],
    code: "https://github.com/KRRISHMK/VIRTUOSO",
    demo: "https://event-management-prod.netlify.app",
    ImgUrl: EventManagement,
  },
  {
    id: 4,
    projectName: "Properties Website",
    projectDesc:
      "This project is based on Properties and Apartments. By using JAM Stack development and the properties data was stored in Strapi CMS.",
    tags: ["React", "Gatsby", "Strapi CMS", "CSS", "Bootstrap"],
    code: "https://github.com/KRRISHMK/chat_zone",
    demo: "https://makesh-properties-gatsby-site.netlify.app/home",
    ImgUrl: Gatsbysite,
  },
];
